export default __webpack_public_path__ + "static/media/card_1.0c555474.png";